<template>
  <a href="/emojile" class="widget-emojile w-[100px] h-[30px] u-center">
    <OImage loading="lazy" src="/images/emojile.png" class="w-[74px] h-[26px]" />
  </a>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OImage },
});
</script>

<style lang="scss">
.widget-emojile {
  background: linear-gradient(166.34deg, #00084d -6.27%, #2c4389 106.87%);
  border-radius: 100px;
}
</style>
